import { PropsWithChildren } from 'react';
import { StyledButton } from './styled';

interface Props {
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'text' | 'icon';
}

function Button({
  onClick,
  variant = 'primary',
  children,
}: PropsWithChildren<Props>) {
  return (
    <StyledButton onClick={onClick} data-variant={variant}>
      {children}
    </StyledButton>
  );
}

export { Button };
